import { Box, Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../../Components/Table/CustomTable'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import actions from '../../../ReduxStore/actions';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { Upload } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import CustomUploadComponent from '../../../Components/CustomExcelUpload/CustomExcelUpload';
import { adminUrl } from '../../../constants';
import { toast, ToastContainer } from 'react-toastify';
import InvalidRowsModal from '../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
// import { IoIosArrowRoundBack } from "react-icons/io";


const KrapKpiManagementHomePage = () => {
    const tableHeadData = ["S.No", "KRA & KPI", "Assessment Year", "Actions"];
    const tableData = [
        { employeeId: "2", krakpi: "SALES", assessmentYear: "2024-2025" },
        { employeeId: "3", krakpi: "SALES", assessmentYear: "2024-2025" },
        { employeeId: "4", krakpi: "SALES", assessmentYear: "2024-2025" },
        { employeeId: "5", krakpi: "SALES", assessmentYear: "2024-2025" },
        { employeeId: "6", krakpi: "SALES", assessmentYear: "2024-2025" },


    ]
    const navigate = useNavigate()

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("KRA & KPI Management"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);
    const { getAllQuestions } = useSelector((state) => state?.getAllQuestions);
    console.log(getAllQuestions, "getAllQuestions")
    const { bulkUploadKraKpiQuestionsFromExcel } = useSelector((state) => state?.bulkUploadKraKpiQuestionsFromExcel);

    const { downloadKraKpiQuestionsSampleExcelFile } = useSelector((state) => state?.downloadKraKpiQuestionsSampleExcelFile);




    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllQuestions"
            };
            const responseData = dispatch(actions.GETALLALLQUESTIONS(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [bulkUploadKraKpiQuestionsFromExcel])
    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")




    useEffect(() => {

        const tempArr = [];
        console.log(getAllQuestions?.data?.data, "mpDta")
        getAllQuestions?.data?.data?.map((data, index) => {
            return tempArr.push({
                kra_kpi_question_id: data?.kra_kpi_question_id,
                id: data?.kra_kpi_id,
                kra_kpi_name: data?.kra_kpi_name,
                appraisal_year: data?.appraisal_year

            });
        });
        setRowTableData(tempArr);




    }, [getAllQuestions])
    const [editData, setEditData] = useState()


    const { getDepartmentById } = useSelector((state) => state?.getDepartmentById);
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle



    const handleTableEdit = async (id) => {
        // setShowExcelUpload(false)

        // console.log(id, "idgretoriut")
        // const data1 = {
        //     data: {},
        //     method: "get",
        //     apiName: `getQuestionById/${id}`
        // };
        // const responseData = await dispatch(actions.GETQUESTIONBYIID(data1));
        // // console.log(responseData, "getDepartmentById")
        // if (responseData?.payload?.message === "KRA/KPI questions successfully.") {
        //     setEditData(responseData?.payload?.data)
        //     navigate(`/admin/editkrakpi/${id}`)
        // }
        navigate(`/admin/editkrakpi/${id}`)



    }
    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)

        if (values?.file) {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUploadKraKpiQuestionsFromExcel/bulk"
            };
            const responseData = await dispatch(actions.BULKUPLOADKRAKPIQUESTIONSFROMEXCEL(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk upload successful.") {
                setLoading(false)
                // toast.success("Bulk upload successful.")
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen()

                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }
    }

    // const handleSamplDownload = () => {

    //     window.open(`${adminUrl}downloadKraKpiQuestionsSampleExcelFile`);
    // }

    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloadKraKpiQuestionsSampleExcelFile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'KRA&KPI_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };


    // const navigate = useNavigate()


    return (
        <div>
            {loading && <FullPageLoader />}
            <Box sx={{ background: "white", px: 3, py: 3 }}>
                {/* <Typography variant="h5" gutterBottom sx={{ color: "black" }}> */}
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        {showExcelUpload ? 'Upload Excel' : 'Create New KRA & KPI'}
                    </Typography>
                    <Typography
                        variant='body1'
                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }}
                        sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography>
                </Box>



                {showExcelUpload ? (


                    < Formik
                        enableReinitialize
                        initialValues={{
                            // departments: editData?.department_name || '',
                            file: null
                        }}
                        // validationSchema={validationSchema}

                        onSubmit={handleSubmit}
                    >
                        {({ errors, touched, handleChange, values, setFieldValue, resetForm, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2} mt={2}>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        {/* {showExcelUpload ? ( */}
                                        <>
                                            <CustomUploadComponent
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                resetForm={resetForm}
                                            />
                                            {/* <Typography variant='body1'
                                                                sx={{
                                                                    // borderBottom: "1px solid var(--main-color)",
                                                                    cursor: "pointer",
                                                                    color: "var(--main-color)"
                                                                }}
                                                            >Download & Sample Excel Format</Typography> */}
                                            {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                            <Typography
                                                onClick={handleSamplDownload}
                                                variant="body1"
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >
                                                Download & Sample Excel Format
                                            </Typography>
                                            {/* </a> */}

                                        </>

                                    </Grid>
                                    <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                        <Button
                                            type="submit"
                                            variant='contained'
                                            disabled={!values?.file}
                                            sx={{
                                                background: "var(--main-color)",
                                                textTransform: "none"
                                            }}
                                        >
                                            {editData?.department_id ? "Update" : "Submit"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                ) : (<Button
                    variant='contained'
                    sx={{ mt: 3, background: 'var(--main-color)', textTransform: "none" }}
                    onClick={() => {
                        navigate("/admin/createkrakpi")
                    }}
                >
                    Create New KRA & KPI
                </Button>)
                }

            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6,
                    // maxWidth: "950px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="KRA & KPI Lists"
                            tableEdit={true}
                            tableActions={true}
                            tableSearch={true}
                            // tableActivate={true}
                            handleTableEdit={handleTableEdit}


                        />

                    </Grid>
                </Grid>

            </Box>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />

            <InvalidRowsModal name="krakapimanagement" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />


        </div >
    )
}

export default KrapKpiManagementHomePage